import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import { formatDate, formatTime } from "../../../../../utils/date-time-utility";
import { CARD_STYLES, COLORS } from "../constants";
import { Payment, PaymentActions } from "../patient-portal-dashboard.types";

interface PaymentCardProps {
  payment: Payment;
  actions?: PaymentActions;
}

const PaymentCard: React.FC<PaymentCardProps> = ({ payment, actions }) => {
  // const [patient] = useCurrentUser();
  // const timezone = patient?.timezone as TimezoneEnum | undefined;

  const handlePayNow = () => actions?.onPayNow?.(payment);

  const serviceDate =
    payment.encounterDate || payment.appointmentDate || payment.dateOfService;

  const dateOfServiceLabel = serviceDate
    ? `${formatDate(serviceDate)} ${formatTime(serviceDate)}`
    : "-";

  const providerLabel = payment.renderingProviderName || "Provider";

  return (
    <Box
      sx={{
        ...CARD_STYLES,
        width: "100%",
        p: 1.5,
        "&:hover": CARD_STYLES.hover,
      }}
    >
      <Flex flexDirection="column" gap={0.5} mb={1.5}>
        <Text size="13px" c={COLORS.detailLabel}>
          Amount Due
        </Text>
        <Typography
          sx={{ fontSize: "18px", fontWeight: 600, color: COLORS.textPrimary }}
        >
          ${payment.amountDue?.toFixed(2) ?? "0.00"}
        </Typography>
      </Flex>

      <Text size="14px" c={COLORS.textSecondary} sx={{ mb: 1.5 }}>
        For visit with{" "}
        <Box
          component="span"
          sx={{ color: COLORS.textPrimary, fontWeight: 500 }}
        >
          {providerLabel}
        </Box>{" "}
        on {dateOfServiceLabel}
      </Text>

      <Flex width="100%" justifyContent="flex-end">
        <Button variant="contained" size="small" onClick={handlePayNow}>
          Pay Now
        </Button>
      </Flex>
    </Box>
  );
};

export default PaymentCard;
